import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Container, Row, Col, Card } from 'react-bootstrap';
import { ArrowLeftCircle, CheckCircle, Cart } from 'react-bootstrap-icons';
import axios from 'axios';
import { API } from '../../../api/URL_API';
import Loader from './componenetes/Loader';
import { useNavigate } from 'react-router-dom';
import icon from '../../../utils/cr1-logo.png';
import FooterPublic from '../FooterPublic';
import WhatsAppButton from '../componentes/WhatsAppButton';
import { useTiendaConfig } from '../../../hooks/useTiendaConfig';

function ViewPedido() {
    const { numPedido } = useParams();
    const [pedido, setPedido] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { whatsappLink } = useTiendaConfig();

    useEffect(() => {
        const fetchPedido = async () => {
            try {
                const response = await axios.get(`${API}/api/verpedidos/carrito/${numPedido}`);
                setPedido(response.data);
            } catch (error) {
                console.error('Error al obtener los datos del pedido:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchPedido();
    }, [numPedido]);

    const redirectToRoot = () => {
        navigate(`/`);
    };

    const getWhatsappUrl = () => {
        if (whatsappLink && typeof whatsappLink.url === 'string' && whatsappLink.url.trim() !== '') {
            return whatsappLink.url;
        }
        return '#';
    };

    if (loading) return <div className="text-center"><Loader /></div>;
    
    if (!pedido || !pedido.productos || pedido.productos.length === 0) {
        return (
            <>
                <Container fluid className="p-0 min-vh-100" style={{ backgroundColor: '#f5efe8' }}>
                    {/* Encabezado minimalista */}
                    <header style={{ backgroundColor: '#2E0205', color: '#f5efe8', padding: '1.5rem 1rem' }}>
                        <Container>
                            <Row className="align-items-center">
                                <Col xs={12} sm={6} className="text-center text-sm-start mb-3 mb-sm-0">
                                    <img src={icon} alt="reymidascaps" width="100" className="img-fluid" style={{ maxWidth: '120px' }} />
                                </Col>
                                <Col xs={12} sm={6} className="text-center text-sm-end">
                                    <Button
                                        className="fw-bold d-inline-flex align-items-center"
                                        onClick={redirectToRoot}
                                        style={{ backgroundColor: '#f5efe8', borderColor: '#f5efe8', color: '#2E0205', fontSize: '0.9rem' }}
                                    >
                                        <ArrowLeftCircle className="me-2" size={18} /> Catálogo
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </header>

                    <Container className="py-5 px-3 px-sm-4">
                        <Row className="justify-content-center">
                            <Col lg={6} md={8} xs={12}>
                                <Card className="border-0 shadow-lg">
                                    <Card.Body className="p-4 p-sm-5 text-center" style={{ backgroundColor: '#e6e0da' }}>
                                        {/* Icono */}
                                        <div className="mb-4">
                                            <Cart size={64} style={{ color: '#2E0205', opacity: 0.5 }} />
                                        </div>

                                        {/* Título */}
                                        <h3 className="fw-bold mb-3" style={{ color: '#2E0205', fontSize: 'clamp(1.25rem, 4vw, 1.75rem)' }}>
                                            Pedido no disponible
                                        </h3>

                                        {/* Mensaje */}
                                        <p className="mb-4" style={{ color: '#555', fontSize: '1rem', lineHeight: 1.6 }}>
                                            Este pedido ya fue enviado o fue anulado.
                                        </p>

                                        {/* Información adicional */}
                                        <div className="p-3 mb-4 rounded" style={{ backgroundColor: '#f5efe8', borderLeft: '4px solid #2E0205' }}>
                                            <p className="mb-0" style={{ color: '#2E0205', fontSize: '0.95rem' }}>
                                                Para más información, comunícate por WhatsApp
                                            </p>
                                        </div>

                                        {/* Botones */}
                                        <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center">
                                            <a
                                                href={getWhatsappUrl()}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="fw-bold d-inline-flex align-items-center justify-content-center"
                                                style={{
                                                    backgroundColor: '#25D366',
                                                    borderColor: '#25D366',
                                                    color: '#fff',
                                                    fontSize: '0.95rem',
                                                    padding: '0.7rem 1.5rem',
                                                    textDecoration: 'none',
                                                    borderRadius: '0.375rem',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#1fac51';
                                                    e.currentTarget.style.transform = 'scale(1.05)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#25D366';
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="18"
                                                    height="18"
                                                    fill="#fff"
                                                    viewBox="0 0 16 16"
                                                    className="me-2"
                                                >
                                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 8.007 0C3.589 0 .002 3.587 0 8.007a7.96 7.96 0 0 0 1.1 4.02L0 16l4.082-1.066a7.94 7.94 0 0 0 3.925 1.002h.003c4.418 0 8.005-3.587 8.007-8.007a7.85 7.85 0 0 0-2.416-5.603zM8.01 14.54a6.52 6.52 0 0 1-3.316-.907l-.238-.14-2.422.633.647-2.361-.154-.243a6.48 6.48 0 0 1-.997-3.514c.002-3.592 2.92-6.51 6.513-6.51a6.46 6.46 0 0 1 4.605 1.905 6.46 6.46 0 0 1 1.906 4.605c-.002 3.592-2.92 6.51-6.514 6.51zm3.58-4.864c-.196-.098-1.157-.57-1.337-.635-.18-.066-.31-.098-.44.098-.13.196-.505.635-.619.766-.114.13-.228.147-.424.049-.196-.098-.828-.305-1.577-.973-.582-.52-.975-1.162-1.09-1.358-.114-.196-.012-.302.086-.4.088-.087.196-.228.294-.342.098-.114.13-.196.196-.327.065-.13.033-.245-.016-.343-.049-.098-.44-1.06-.602-1.45-.158-.379-.319-.327-.44-.333-.114-.006-.245-.007-.376-.007-.13 0-.343.049-.522.245-.18.196-.686.67-.686 1.634 0 .964.702 1.895.8 2.025.098.13 1.382 2.11 3.35 2.957.469.202.835.323 1.12.414.47.15.897.129 1.235.078.377-.056 1.157-.473 1.321-.93.163-.457.163-.848.114-.93-.049-.082-.18-.13-.376-.228z" />
                                                </svg>
                                                WhatsApp
                                            </a>
                                            <Button
                                                className="fw-bold d-inline-flex align-items-center justify-content-center"
                                                onClick={redirectToRoot}
                                                style={{ backgroundColor: '#2E0205', borderColor: '#2E0205', color: '#f5efe8', fontSize: '0.95rem', padding: '0.7rem 1.5rem' }}
                                            >
                                                <ArrowLeftCircle className="me-2" size={18} /> Volver al Catálogo
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                <WhatsAppButton />
                <FooterPublic />
            </>
        );
    }

    const totalItems = pedido.productos.reduce((acc, item) => acc + item.cantidad, 0);
    const totalProductos = pedido.productos.reduce((acc, item) => acc + item.subtotal, 0);

    const formatCop = (value) => value?.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }) || '$0';

    const textoEnvio =
        pedido.costoEnvio > 0
            ? formatCop(pedido.costoEnvio)
            : '+ Costo de envío';

    return (
        <>
            <Container fluid className="p-0 min-vh-100" style={{ backgroundColor: '#f5efe8' }}>
                {/* Encabezado minimalista */}
                <header style={{ backgroundColor: '#2E0205', color: '#f5efe8', padding: '1.5rem 1rem' }}>
                    <Container>
                        <Row className="align-items-center">
                            <Col xs={12} sm={6} className="text-center text-sm-start mb-3 mb-sm-0">
                                <img src={icon} alt="reymidascaps" width="100" className="img-fluid" style={{ maxWidth: '120px' }} />
                            </Col>
                            <Col xs={12} sm={6} className="text-center text-sm-end">
                                <Button
                                    className="fw-bold d-inline-flex align-items-center"
                                    onClick={redirectToRoot}
                                    style={{ backgroundColor: '#f5efe8', borderColor: '#f5efe8', color: '#2E0205', fontSize: '0.9rem' }}
                                >
                                    <ArrowLeftCircle className="me-2" size={18} /> Catálogo
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </header>

                <Container className="py-4 px-3 px-sm-4">

                    {/* Status del pedido */}
                    <div className="mb-4 p-3 rounded" style={{ backgroundColor: '#e6e0da', borderLeft: '4px solid #2E0205' }}>
                        <div className="d-flex align-items-center">
                            <CheckCircle className="me-2" size={24} style={{ color: '#2E0205' }} />
                            <div>
                                <p className="mb-1 fw-bold" style={{ color: '#2E0205' }}>Pedido Confirmado</p>
                                <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>Número: <strong className="color-primary">{pedido.numPedido}</strong></p>
                            </div>
                        </div>
                    </div>

                    <Row className="g-3">
                        {/* Información General */}
                        <Col lg={6} xs={12}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header style={{ backgroundColor: '#2E0205', color: '#f5efe8' }} className="fw-bold d-flex align-items-center py-3">
                                    <CheckCircle className="me-2" size={20} /> Información del Pedido
                                </Card.Header>
                                <Card.Body className="p-3" style={{ backgroundColor: '#e6e0da' }}>
                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Fecha</p>
                                        <p className="fw-bold mb-0 color-primary">{new Date(pedido.creacion).toLocaleDateString('es-CO')}</p>
                                    </div>

                                    {(pedido.nombreCliente || pedido.telefonoCliente) && (
                                        <div className="mb-3 pb-3 border-bottom">
                                            <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Cliente</p>
                                            <p className="fw-bold mb-0 color-primary">{pedido.nombreCliente || 'No registrado'}</p>
                                            {pedido.telefonoCliente && <p className="mb-0 color-primary" style={{ fontSize: '0.85rem' }}>Tel: {pedido.telefonoCliente}</p>}
                                        </div>
                                    )}

                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Items Totales</p>
                                        <p className="fw-bold mb-0 color-primary">{totalItems} artículos</p>
                                    </div>

                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Subtotal</p>
                                        <p className="fw-bold mb-0 color-primary">{formatCop(totalProductos)}</p>
                                    </div>

                                    {pedido.descuento > 0 && (
                                        <div className="mb-3 pb-3 border-bottom">
                                            <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Descuento</p>
                                            <p className="fw-bold mb-0 text-danger">{pedido.descuento}%</p>
                                        </div>
                                    )}

                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Costo de Envío</p>
                                        <p className="fw-bold mb-0 color-primary">
                                            {textoEnvio}
                                        </p>
                                    </div>

                                    <div className="pt-2" style={{ backgroundColor: '#f5efe8', padding: '12px', borderRadius: '6px' }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total del Pedido</p>
                                        <p className="fw-bold mb-0 color-primary" style={{ fontSize: '1.5rem' }}>{formatCop(pedido.totalPedido)}</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Resumen de Productos */}
                        <Col lg={6} xs={12}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header style={{ backgroundColor: '#2E0205', color: '#f5efe8' }} className="fw-bold d-flex align-items-center py-3">
                                    <Cart className="me-2" size={20} /> Productos
                                </Card.Header>
                                <Card.Body className="p-3" style={{ backgroundColor: '#e6e0da' }}>
                                    <div>
                                        {pedido.productos.map((item, index) => (
                                            <div key={index} className="mb-3 pb-3 border-bottom" style={{ display: 'flex', gap: '12px', backgroundColor: '#e6e0da' }}>
                                                <img
                                                    src={item.imgProducto}
                                                    alt={item.nomProducto}
                                                    width="70"
                                                    height="70"
                                                    className="rounded"
                                                    style={{ objectFit: 'contain', backgroundColor: '#e6e0da', padding: '4px', flex: '0 0 70px' }}
                                                />
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <p className="fw-bold mb-1" style={{ fontSize: '0.95rem', color: '#2E0205', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {item.nombreOriginal || item.nomProducto}
                                                    </p>
                                                    <p className="text-muted mb-1" style={{ fontSize: '0.85rem' }}>
                                                        Cantidad: <strong className="color-primary">{item.cantidad}</strong>
                                                    </p>
                                                    <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
                                                        Precio: <strong className="color-primary">{formatCop(item.precioU)}</strong>
                                                    </p>
                                                    <p className="fw-bold mb-0" style={{ fontSize: '0.9rem', color: '#2E0205' }}>
                                                        Subtotal: {formatCop(item.subtotal)}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                </Container>
            </Container>
            <WhatsAppButton />
            <FooterPublic />
        </>
    );
}

export default ViewPedido;
